var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5-10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}))));
export default SvgIconHandle;